'use strict';
var lengthOfArrayLike = require('../internals/length-of-array-like');

module.exports = function (Constructor, list, $length) {
  var index = 0;
  var length = arguments.length > 2 ? $length : lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/array-from-constructor-and-list.js
// module id = 366
// module chunks = 0